export default __webpack_public_path__ + "static/media/Padron_50.8d880e23.jpg";